import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Page } from 'libraries/Page';
import { Line } from 'libraries/Line';
import { Fonts } from 'domain-models/Fonts';
import { FontCharacters } from 'domain-models/FontCharacters';
import { Helper } from 'libraries/Helper';

@Component({
	selector: 'page-message',
	templateUrl: './page-message.component.html',
	styleUrls: ['./page-message.component.css']
})
export class PageMessageComponent implements OnInit {
	@Input('page') page: Page;
	@Input('enable') enable: boolean;
	@Output('fontValue') fontValue = new EventEmitter<Fonts>();
	previousValue;
	constructor() {}

	ngOnInit() {}

	test() {
		console.log('works');
	}

	setActiveLine(line: Line) {
		this.page.lines.forEach((myline) => {
			if (line == myline) {
				myline.isActive = true;
				this.fontValue.emit(myline.font);
			} else myline.isActive = false;
		});
	}

	updateCharacterCount(line: Line, event) {
		if (isFinite(event)) {
			line.characterPixelCount = event;
		}
	}

	runChecks(line: Line, event: Event) {
		console.log(event);
		console.log('running checks');
		let counter = 0;
		let maxPixels = line.maximunCharacter;
		let tooLong = false;
		let fontCharacters = JSON.parse(localStorage.getItem('fontCharacters-' + line.font.Id));

		let justifications = [];
		for (let i = 0; i < 5; i++) {
			if (line.justifications[i]) {
				justifications[i] = line.justifications[i];
				console.log('Justified section: ' + i);
			}
		}

		justifications.forEach((text) => {
			text.split('').forEach((character) => {
				// Calculate the number of pixels taken up by this character
				//search the character in the FontCharacter object array, and return the fontcharacter object
				// so if you are looking for A, the return will be: {WidthInPixels:5, OtherProperty:ItsValue}
				if (character == ' ') character = ''; //change space to "" because for some reason the API is not returning the blank space
				var fontCharacter: FontCharacters = fontCharacters.find(
					(font) => font.AsciiValue === character
				);
				console.log(fontCharacter);
				if (fontCharacter) {
					counter += fontCharacter.WidthInPixels + line.font.CharSpacing; //Increase the local counter with the width of the character you got from the table
					if (counter > maxPixels) {
						//if counter exceeds
						counter -= fontCharacter.WidthInPixels + line.font.CharSpacing; //delete the just added width
						tooLong = true; //enable the flag
						// Helper.showNotification("top", "right", "You have reached the limit of characters", 4);//show message
						return; //break the foreach
					}
					//index++;//increase the index
				} else {
					//if the character was not found show message, and behive like its to long so that it will delete it
					Helper.showNotification(
						'top',
						'right',
						'That character is not available for this Font. Please choose a different font',
						4
					);
					//tooLong = true;
					return;
				}
			});
		});
		if (tooLong) {
			Helper.alert('Message too long!');
			line.justifications = { ...this.previousValue };
		}
		this.previousValue = { ...line.justifications };
		line.characterPixelCount = counter;
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/page-message/page-message.component.ts